import React from "react";
import { ReactComponent as GencoinGemsIcon } from "../assets/gencoin-gems.svg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Loader from "../components/animated/Loader";

function OrgBenefit() {
  // Set up Intersection Observer hook
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 1, // Trigger when 100% of the element is visible
  });

  const { ref: mobileRef, inView: mobileInView } = useInView({
    triggerOnce: false,
    threshold: 0.001, // Trigger when 100% of the element is visible
  });

  const whyOrganizationsChooseGeneros = [
    {
      title: "Sustainable Revenue",
      description:
        "Generators create ongoing funding, not just one-time donations",
    },
    {
      title: "Deeper Engagement",
      description:
        "Supporters become invested stakeholders, not passive donors",
    },
    {
      title: "Network Growth",
      description: "Each generator can attract other generators to your cause",
    },
    {
      title: "Zero Fundraising Costs",
      description: "Automated generation replaces expensive campaigns",
    },
  ];

  //   Why Organizations Choose Generos:

  // Sustainable Revenue - Generators create ongoing funding, not just one-time donations
  // Deeper Engagement - Supporters become invested stakeholders, not passive donors
  // Network Growth - Each generator can attract other generators to your cause
  // Zero Fundraising Costs - Automated generation replaces expensive campaigns

  // For Your Supporters:
  // Instead of donor fatigue, they experience generator excitement. Instead of feeling depleted by giving, they feel empowered by earning while supporting your mission.

  return (
    <section>
      <div
        className="flex w-full max-w-6xl mx-auto px-4 sm:px-6 items-center"
        data-aos-id-gen-method-anchor
      >
        <div className="pt-20 border-t border-gray-800">
          <div className="">
            {/* Mobile */}
            <div className="md:hidden flex flex-col items-center">
              <div
                className="flex flex-col items-center mb-10"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="flex justify-center items-center h-16 mb-10 w-full">
                  <Loader className="w-1/2" isPrimaryColor={true} />
                </div>

                <div className="flex flex-col text-center items-start justify-center mt-24 w-full">
                  <div className="h1 mb-2 text-xxl text-white">
                    Organizations: Partner With Your Supporters, Don't Just Beg
                    From Them
                  </div>

                  <p className="font-bold text-3xl text-primary-1 italic mb-4 text-center w-full mt-6">
                    Move beyond the charity sacrifice model.
                  </p>
                  <p className="font-bold text-3xl text-primary-1 italic mb-4 text-center w-full">
                    Start offering partnership and community.
                  </p>
                  <p className="text-3xl text-white mb-8 text-center w-full">
                    Transform one-sided donations into regenerative
                    relationships where supporters grow financially while
                    funding your mission.
                  </p>
                </div>
                {/* <div
                  className="flex flex-col items-center justify-center w-full"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <a
                    className="btn text-lg rounded-lg font-bold text-white bg-purple-600 hover:bg-purple-700 w-full mb-4 sm:w-auto sm:mb-0"
                    href={`${process.env.REACT_APP_GENEROS_DOCS_URI}/user-guides/understanding-value-flow-in-generos-gems-gencoin-and-impact`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Learn More
                  </a>
                </div> */}
              </div>
            </div>

            {/* Desktop and Tablet */}
            <div className="hidden md:flex flex-col w-full">
              <div
                className="flex mb-36 items-center"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="flex justify-center items-center h-16 mb-2 w-full">
                  <Loader className="w-5/6" isPrimaryColor={true} />
                </div>

                <div className="flex flex-col items-start justify-center pl-6">
                  <div className="h1 mb-2 text-xxl text-white">
                    Organizations: Partner With Your Supporters, Don't Just Beg
                    From Them
                  </div>

                  <p className="text-3xl text-white mb-10">
                    <span className="font-bold text-primary-1 italic mb-4 mr-2">
                      Move beyond the charity sacrifice model. Start offering
                      partnership and community.
                    </span>
                    Transform one-sided donations into regenerative
                    relationships where supporters grow financially while
                    funding your mission.
                  </p>
                  {/* <div data-aos="fade-up" data-aos-delay="400">
                    <a
                      className="btn text-lg rounded-lg font-bold text-white bg-purple-600 hover:bg-purple-700 w-full mb-4 sm:w-auto sm:mb-0"
                      href={`${process.env.REACT_APP_GENEROS_DOCS_URI}/user-guides/understanding-value-flow-in-generos-gems-gencoin-and-impact`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Learn More
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OrgBenefit;
